<script setup lang="ts">
const isExpanded = ref(false)
const toggle = () => {
  isExpanded.value = !isExpanded.value
}
</script>

<template>
  <div class="show-more-container">
    <div class="content-wrapper" :class="{ expanded: isExpanded }">
      <slot />
      <div v-if="!isExpanded" class="shadow-overlay"></div>
    </div>
    <button class="button -primary" @click="toggle">
      {{ isExpanded ? 'Zobraziť menej' : 'Zobraziť viac' }}
      <i v-if="isExpanded" class="ico ico-chevron-up"></i>
      <i v-else class="ico ico-chevron-down"></i>
    </button>
  </div>
</template>

<style scoped>
.show-more-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  max-height: 150px;
  overflow: hidden;
  position: relative;
  transition: max-height 0.3s ease;
}

.content-wrapper.expanded {
  max-height: none;
  padding-bottom: 40px;
}

.shadow-overlay {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
  pointer-events: none;
}

.button {
  & {
    margin-inline: auto;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .ico {
    & {
      font-size: 10px;
    }
  }
}
</style>
